module.exports = __webpack_public_path__ + "static/media/bottle-burgundy.fd5d5e61.png";